var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('InvoiceSearch',{on:{"invoiceupdated":i => _vm.updateInvoice(i)}}),_c('v-divider'),_c('InvoiceDetails',{ref:"invoiceDetails",attrs:{"invoices":_vm.invoices}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }